export const SCHEDULER = {
  PASTE_ACTIVITY_IDS_DIALOG: {
    DIALOG: 'paste-activity-ids-dialog',
    CLOSE: 'paste-activity-ids-dialog-close',
    MAPPING_INFO: 'paste-activity-ids-dialog-mapping-info',
    CONFIRM_MAPPING: 'paste-activity-ids-dialog-confirm-mapping',
    COLUMN_SELECT: 'paste-activity-ids-dialog-column-select',
    STATUS_ALERT: 'paste-activity-ids-dialog-status-alert',
    RENUMBER_ALL: 'paste-activity-ids-dialog-renumber-all',
    ID_INPUT: 'paste-activity-ids-dialog-id-input',
    TEXTBOX: 'paste-activity-ids-dialog-textbox',
    CANCEL: 'paste-activity-ids-dialog-cancel',
    PASTE: 'paste-activity-ids-dialog-paste'
  },
  SCHEDULER_SETTINGS: {
    // Dialog
    DIALOG: 'scheduler-settings-dialog',
    DIALOG_TITLE: 'scheduler-settings-dialog-title',
    DIALOG_CLOSE: 'scheduler-settings-dialog-close',

    // Sliders
    MIN_ZOOM_SLIDER: 'scheduler-settings-min-zoom-slider',
    SEARCH_THRESHOLD_SLIDER: 'scheduler-settings-search-threshold-slider',
    AUTO_SPACING_SLIDER: 'scheduler-settings-auto-spacing-slider',
    NODE_BORDER_SLIDER: 'scheduler-settings-node-border-slider',

    // Debug settings
    DEBUG_ACCORDION: 'scheduler-settings-debug-accordion',
    DEBUG_PROPAGATE_SWITCH: 'scheduler-settings-debug-propagate-switch',
    DEBUG_SNAP_GRID_SWITCH: 'scheduler-settings-debug-snap-grid-switch',
    DEBUG_CHILDREN_BOUNDS_SWITCH: 'scheduler-settings-debug-children-bounds-switch',
    DEBUG_UGLY_EDGE_SWITCH: 'scheduler-settings-debug-ugly-edge-switch',
    DEBUG_TABLE_NAV_SWITCH: 'scheduler-settings-debug-table-nav-switch',
    DEBUG_CONSOLE_LOGS_SWITCH: 'scheduler-settings-debug-console-logs-switch',
    DEBUG_DEBUGGING_SWITCH: 'scheduler-settings-debug-debugging-switch',
    DEBUG_DHTMLX_SWITCH: 'scheduler-settings-debug-dhtmlx-switch',
    DEBUG_P6_DUMMY_SWITCH: 'scheduler-settings-debug-p6-dummy-switch',
    DEBUG_MPP_DUMMY_SWITCH: 'scheduler-settings-debug-mpp-dummy-switch',
    DEBUG_SCROLL_BUTTON_SWITCH: 'scheduler-settings-debug-scroll-button-switch',
    DEBUG_PERFORMANCE_DIAGNOSTICS_SWITCH: 'scheduler-settings-debug-performance-diagnostics-switch',
    DEBUG_MAX_LABEL_EDGE_MARKER_SWITCH: 'scheduler-settings-debug-max-label-edge-marker-switch',
    DEBUG_PASTE_ACTIVITY_IDS_DIALOG_SWITCH: 'scheduler-settings-debug-paste-activity-ids-dialog-switch',
    DEBUG_RESET_TUTORIALS: 'scheduler-settings-debug-reset-tutorials',
    DEBUG_WS_FAILURE_SELECT: 'scheduler-settings-debug-ws-failure-select',

    // Copy values
    COPY_TOKEN: 'scheduler-settings-copy-token',
    COPY_USER_ID: 'scheduler-settings-copy-user-id',
    COPY_ORG_ID: 'scheduler-settings-copy-org-id',
    COPY_WORKSPACE_ID: 'scheduler-settings-copy-workspace-id',

    // Server debug
    SERVER_DEBUG_ACCORDION: 'scheduler-settings-server-debug-accordion',
    SERVER_CLEAR_PROJECT: 'scheduler-settings-server-clear-project',
    SERVER_CLEAR_ORG: 'scheduler-settings-server-clear-org',
    SERVER_DOWNLOAD_PROJECT: 'scheduler-settings-server-download-project',
    SERVER_DOWNLOAD_ORG: 'scheduler-settings-server-download-org',

    // LocalHost options
    LOCALHOST_ACCORDION: 'scheduler-settings-localhost-accordion',
    LOCALHOST_ORG_SELECT: 'scheduler-settings-localhost-org-select',
    LOCALHOST_SERVICES_SELECT: 'scheduler-settings-localhost-services-select',
    LOCALHOST_COLLAB_SELECT: 'scheduler-settings-localhost-collab-select',
    LOCALHOST_PDF_SELECT: 'scheduler-settings-localhost-pdf-select'
  },
  COMBO_SEARCH: {
    // Main container
    CONTAINER: 'combo-search-container',
    TREE_VIEW: 'combo-search-tree-view',
    TREE_ITEM: 'combo-search-tree-item',
    TREE_ITEM_LABEL: 'combo-search-tree-item-label',

    // Search
    SEARCH_HIGHLIGHTER: 'combo-search-highlighter',

    // Actions
    CONNECT_BUTTON: 'combo-search-connect-button',
    MOVE_HERE_BTN: 'combo-search-move-here-button',
    SELECT_BUTTON: 'combo-search-select-button',
    WATCH_BUTTON: 'combo-search-watch-button',
    GOTO_BUTTON: 'combo-search-goto-button',

    // Scroll
    SCROLL_TO_BUTTON: 'combo-search-scroll-to-button',
    SCROLL_TO_BUTTON_TEXT: 'combo-search-scroll-to-button-text',

    // More menu
    MORE_MENU_BUTTON: 'combo-search-more-menu-button',
    MORE_MENU_ICON: 'combo-search-more-menu-icon',

    // Expand groups
    EXPAND_GROUPS_MENU: 'combo-search-expand-groups-menu',
    EXPAND_GROUPS_LEVEL: 'combo-search-expand-groups-level'
  },
  TREE_NAVIGATION_MENU: {
    SEARCH_INPUT: 'tree-navigation-menu-search-input',
    SEARCH_INPUT_FIELD: 'tree-navigation-menu-search-input-field',
    TITLE_BAR: 'tree-navigation-menu-title-bar',
    TITLE: 'tree-navigation-menu-title',
    WRAPPER: 'tree-navigation-menu-wrapper',
    CLOSE_BUTTON: 'tree-navigation-menu-close-button',
    COMBOBOX_TITLE_BAR: 'tree-navigation-menu-combobox-title-bar',
    SEARCH_ICON: 'tree-navigation-menu-search-icon',
    SEARCH_CLOSE_ICON: 'tree-navigation-menu-search-close-icon',
    GROUP_REORDER_NAV_BUTTON: 'tree-navigation-menu-group-reorder-nav-button'
  },
  GROUP_REORDER: {
    PAGE: 'scheduler-group-reorder-page',
    BACK_TO_PROJECT_BUTTON: 'scheduler-group-reorder-back-to-project-button',
    UNDO_BUTTON: 'scheduler-group-reorder-undo-button',
    FLOATING_TOOLBAR: 'scheduler-group-reorder-floating-toolbar',
    SHORTCUTS_BUTTON: 'scheduler-group-reorder-shortcuts-button',
    SHORTCUTS_POPOVER: 'scheduler-group-reorder-shortcuts-popover',
    SHORTCUTS_POPOVER_CLOSE_BUTTON: 'scheduler-group-reorder-shortcuts-popover-close-button',
    CLOSE_BUTTON: 'scheduler-group-reorder-close-button',
    ENTRY_DIALOG: 'scheduler-group-reorder-entry-dialog',
    ENTRY_DIALOG_ACTIVE_USERS: 'scheduler-group-reorder-entry-dialog-active-users',
    ENTRY_DIALOG_ACTIVE_USER: 'scheduler-group-reorder-entry-dialog-active-user',
    ENTRY_DIALOG_CANCEL_BUTTON: 'scheduler-group-reorder-entry-dialog-cancel-button',
    ENTRY_DIALOG_CONTINUE_BUTTON: 'scheduler-group-reorder-entry-dialog-continue-button',
    GRID_WRAPPER: 'scheduler-group-reorder-grid-wrapper',
    GRID_INNER_WRAPPER: 'scheduler-group-reorder-grid-inner-wrapper',
    NAME_CELL_WRAPPER: 'scheduler-group-reorder-name-cell-wrapper',
    NAME_CELL_GROUP_VALUE: 'scheduler-group-reorder-name-cell-group-value',
    NAME_CELL_EXPANDED_TOGGLE: 'scheduler-group-reorder-name-cell-expanded-toggle',
    NAME_CELL_CONTRACTED_TOGGLE: 'scheduler-group-reorder-name-cell-contracted-toggle',
    PROMOTE_GROUP_BUTTON: 'scheduler-group-reorder-promote-group-button',
    REFRESH_DATA_BUTTON: 'scheduler-group-reorder-refresh-data-button',
    NAVIGATE_TO_CANVAS: 'scheduler-group-reorder-navigate-to-canvas',
    NAVIGATE_TO_TABLE: 'scheduler-group-reorder-navigate-to-table',
    NAVIGATE_TO_GANTT: 'scheduler-group-reorder-navigate-to-gantt',
    ROW_MENU_TRIGGER: 'scheduler-group-reorder-row-menu-trigger',
    SHOW_GROUPS_TO_LEVEL_TRIGGER: 'scheduler-group-reorder-show-groups-to-level-trigger',
    SHOW_GROUPS_TO_LEVEL_ITEM: 'scheduler-group-reorder-show-groups-to-level-item',
    COPY_GROUP: 'scheduler-group-reorder-copy-group',
    PASTE_GROUP_BELOW: 'scheduler-group-reorder-paste-group-below',
    PASTE_GROUP_INSIDE: 'scheduler-group-reorder-paste-group-inside',
    DELETE_GROUP: 'scheduler-group-reorder-delete-group'
  },
  EMBED_MIRO_BOARD_DIALOG: {
    DIALOG: 'embed-miro-board-dialog'
  },
  TABLE: {
    // Main container
    CONTAINER: 'scheduler-table-container',
    STANDALONE_CONTAINER: 'scheduler-table-standalone-container',
    HEADER_CONTAINER: 'scheduler-table-header-container',

    // Custom fields dialog
    NEW_FIELDS_ADD: 'scheduler-table-custom-new-fields-add',
    CUSTOM_FIELDS_DIALOG: 'scheduler-table-custom-fields-dialog',
    CUSTOM_FIELDS_HEADER: 'scheduler-table-custom-fields-header',
    CUSTOM_FIELDS_ITEM: 'scheduler-table-custom-fields-item',
    CUSTOM_FIELDS_ADD: 'scheduler-table-custom-fields-add',
    CUSTOM_FIELDS_SAVE: 'scheduler-table-custom-fields-save',
    CUSTOM_FIELDS_CANCEL: 'scheduler-table-custom-fields-cancel'
  },
  USER_LIBRARY: {
    // Container
    CONTAINER: 'scheduler-user-library-container',
    ACTIONS_CONTAINER: 'scheduler-user-library-actions-container'
  },
  RESOURCE_LIBRARY: {
    // Container
    CONTAINER: 'scheduler-resource-library-container',

    // Grid
    GRID_CONTAINER: 'scheduler-resource-library-grid-container',
    GRID: 'scheduler-resource-library-grid',

    // Search
    SEARCH_INPUT: 'scheduler-resource-library-search-input',
    SEARCH_CLEAR: 'scheduler-resource-library-search-clear',

    // Create button
    CREATE_BUTTON: 'scheduler-resource-library-create-button',
    CREATE_BUTTON_ICON: 'scheduler-resource-library-create-button-icon',
    CREATE_BUTTON_TEXT: 'scheduler-resource-library-create-button-text',

    // Slide button
    SLIDE_BUTTON: 'scheduler-resource-library-slide-button',

    // Empty states
    EMPTY_STATE_LABOR: 'scheduler-resource-library-empty-state-labor',
    EMPTY_STATE_EQUIPMENT: 'scheduler-resource-library-empty-state-equipment'
  },
  HEADERS: {
    // More menu
    MORE_MENU: 'scheduler-headers-more-menu',
    MORE_MENU_BUTTON: 'scheduler-headers-more-menu-button',
    MORE_MENU_BUTTON_ICON: 'scheduler-headers-more-menu-button-icon',
    MORE_MENU_BACK: 'scheduler-headers-more-menu-back',
    MORE_MENU_CLOSE: 'scheduler-headers-more-menu-close',

    // Printable header
    PRINTABLE_HEADER: 'scheduler-headers-printable-header',
    PRINTABLE_HEADER_ICON: 'scheduler-headers-printable-header-icon',
    PRINTABLE_HEADER_SELECTED_ORGANIZATION_ICON: 'printable-header-selected-organization-icon',

    // Time display
    TIME_DISPLAY_ABSOLUTE: 'scheduler-headers-time-display-absolute',
    TIME_DISPLAY_RELATIVE: 'scheduler-headers-time-display-relative',

    // Project actions
    PROJECT_SETTINGS: 'scheduler-headers-project-settings',
    PROJECT_CHANGELOG: 'scheduler-headers-project-changelog',
    PROJECT_EXPORT: 'scheduler-headers-project-export',
    PROJECT_COLLECTION_EXPORT: 'scheduler-headers-project-collection-export',
    QUALITY_SCORE: 'scheduler-headers-quality-score',
    PROJECT_EXPORT_PROCORE: 'scheduler-headers-project-export-procore',
    PROJECT_STATE: 'scheduler-headers-project-state',
    DEVELOPER_SETTINGS: 'scheduler-headers-developer-settings',

    // Canvas actions
    CANVAS_PDF: 'scheduler-headers-canvas-pdf',

    // Gantt actions
    GANTT_ORGANIZE: 'scheduler-headers-gantt-organize',
    GANTT_PDF: 'scheduler-headers-gantt-pdf',
    GANTT_TIME_DISPLAY: 'scheduler-headers-gantt-time-display',

    // Progress updates
    PROGRESS_UPDATES: 'scheduler-headers-progress-updates',

    // Docked Manny (temporary)
    DOCKED_MANNY: 'scheduler-headers-docked-manny',

    // Demo menu
    DEMO_MENU: 'scheduler-headers-demo-menu',
    DEMO_HOME: 'scheduler-headers-demo-home',
    DEMO_RESOURCES: 'scheduler-headers-demo-resources',
    DEMO_CODES: 'scheduler-headers-demo-codes'
  },
  FLOATING_PANEL: {
    // Buttons
    TABLE_CLOSE_BUTTON: 'scheduler-floating-panel-table-close-button',
    TABLE_CLOSE_ICON: 'scheduler-floating-panel-table-close-icon',
    RESIZABLE_DIALOG: 'scheduler-floating-panel-resizable-dialog',

    // Empty state
    EMPTY_CONTAINER: 'scheduler-floating-panel-empty-container',
    EMPTY_ICON: 'scheduler-floating-panel-empty-icon',
    EMPTY_TEXT: 'scheduler-floating-panel-empty-text',
    EMPTY_CLOSE: 'scheduler-floating-panel-empty-close',

    // Data panel
    DATA_PANEL: 'scheduler-floating-panel-data-panel',
    STATUS_PANEL: 'scheduler-floating-panel-status-panel',

    // Table
    TABLE: 'scheduler-floating-panel-table',

    // Relationships
    RELATIONSHIPS: 'scheduler-floating-panel-relationships',
    RELATIONSHIPS_CLOSE: 'scheduler-floating-panel-relationships-close'
  },
  DATA_PANEL: {
    // Main container and sections
    STATUS_PANEL_WRAP: 'scheduler-data-panel-status-panel-wrap',
    STATUS_PANEL_TITLE_TEXT: 'scheduler-data-panel-status-panel-title-text',
    DATA_PANEL_CLOSE_ICON: 'scheduler-data-panel-close-icon',
    STATUS_DEFAULT_CLOSE_ICON: 'scheduler-data-panel-status-default-close-icon',
    CONTAINER: 'scheduler-data-panel-container',
    HEADER: 'scheduler-data-panel-header',
    CLOSE_BUTTON: 'scheduler-data-panel-close-button',
    CLOSE_ICON: 'scheduler-data-panel-close-icon',
    CONTENT: 'scheduler-data-panel-content',
    WORKING_SCHEDULE_UPDATES_STATUS: 'scheduler-data-panel-working-schedule-updates-status',
    WORKING_SCHEDULE_UPDATES_PLANNED_DATE: 'scheduler-data-panel-working-schedule-updates-planned-date',
    WORKING_SCHEDULE_UPDATES_ACTUAL_START_DATE: 'scheduler-data-panel-working-schedule-updates-start-date',
    WORKING_SCHEDULE_UPDATES_FINISH_DATE: 'scheduler-data-panel-working-schedule-updates-finish-date',
    WORKING_SCHEDULE_UPDATES_DURATION: 'scheduler-data-panel-working-schedule-updates-duration',
    WORKING_SCHEDULE_UPDATES_DATA_DATE: 'scheduler-data-panel-working-schedule-updates-data-date',
    MASTER_SCHEDULE_UPDATES_DATA_DATE: 'scheduler-data-panel-master-schedule-updates-data-date',

    // Apply/Sync button
    APPLY_SYNC_BUTTON: 'scheduler-data-panel-apply-sync-button',
    APPLY_SYNC_UNDO_BUTTON: 'scheduler-data-panel-apply-sync-undo-button',
    APPLY_SYNC_TOOLTIP: 'scheduler-data-panel-apply-sync-tooltip',

    // Working Schedule Updates
    WORKING_SCHEDULE_UPDATES_CONTAINER: 'scheduler-data-panel-working-schedule-updates',
    WORKING_SCHEDULE_UPDATES_ITEM: 'scheduler-data-panel-working-schedule-update-item',
    WORKING_SCHEDULE_UPDATES_ACCEPT: 'scheduler-data-panel-working-schedule-update-accept',
    WORKING_SCHEDULE_UPDATES_REJECT: 'scheduler-data-panel-working-schedule-update-reject',

    // Variance Code Picker
    VARIANCE_CODE_PICKER: 'scheduler-data-panel-variance-code-picker',
    VARIANCE_CODE_OPTION: 'scheduler-data-panel-variance-code-option',

    // Progress Pill
    PROGRESS_PILL: 'scheduler-data-panel-progress-pill',
    PROGRESS_PILL_ICON: 'scheduler-data-panel-progress-pill-icon',

    // Info Tooltip
    INFO_TOOLTIP: 'scheduler-data-panel-info-tooltip',
    INFO_TOOLTIP_CONTENT: 'scheduler-data-panel-info-tooltip-content',

    // Status Update Audit
    STATUS_UPDATE_AUDIT_TOOLTIP: 'scheduler-data-panel-status-update-audit-tooltip',
    STATUS_UPDATE_AUDIT_CONTENT: 'scheduler-data-panel-status-update-audit-content',
    STATUS_UPDATE_AUDIT_BUTTON: 'scheduler-data-panel-status-update-audit-button',

    // Basic Date Picker
    START_DATE_PICKER: 'scheduler-data-panel-start-date-picker',
    FINISH_DATE_PICKER: 'scheduler-data-panel-finish-date-picker',
    EMPTY_FINISH_DATE_PICKER_INPUT: 'scheduler-data-panel-empty-finish-date-picker-input',
    DATE_PICKER_CALENDAR: 'scheduler-data-panel-date-picker-calendar',
    DURATION_INPUT: 'scheduler-data-panel-duration-input',

    // Project Data Date Dialog
    DATA_DATE_DIALOG: 'scheduler-data-panel-data-date-dialog',
    DATA_DATE_DIALOG_CLOSE: 'scheduler-data-panel-data-date-dialog-close',
    DATA_DATE_DIALOG_SAVE: 'scheduler-data-panel-data-date-dialog-save',
    DATA_DATE_DIALOG_CANCEL: 'scheduler-data-panel-data-date-dialog-cancel',
    OUT_OF_SEQUENCE_WARNING: 'scheduler-data-panel-out-of-sequence-warning',

    // Update Data Date Popover (In Progress)
    UPDATE_DATA_DATE_POPOVER: 'scheduler-data-panel-update-data-date-popover',
    UPDATE_DATA_DATE_POPOVER_HEADER: 'scheduler-data-panel-update-data-date-popover-header',
    UPDATE_DATA_DATE_POPOVER_CLOSE: 'scheduler-data-panel-update-data-date-popover-close',
    UPDATE_DATA_DATE_POPOVER_IGNORE: 'scheduler-data-panel-update-data-date-popover-ignore',
    UPDATE_DATA_DATE_POPOVER_UPDATE_TO_TODAY: 'scheduler-data-panel-update-data-date-popover-update-to-today'
  },
  CALENDARS: {
    // Main components
    GRID_CONTAINER: 'scheduler-calendars-grid-container',

    // Calendar Wizard
    WIZARD_DIALOG: 'scheduler-calendars-wizard-dialog',
    WIZARD_CLOSE_BUTTON: 'scheduler-calendars-wizard-close-button',
    WIZARD_BACK_BUTTON: 'scheduler-calendars-wizard-back-button',
    WIZARD_NEXT_BUTTON: 'scheduler-calendars-wizard-next-button',
    WIZARD_FINISH_BUTTON: 'scheduler-calendars-wizard-finish-button',
    WIZARD_NAME_INPUT: 'scheduler-calendars-wizard-name-input',
    WIZARD_DESCRIPTION_INPUT: 'scheduler-calendars-wizard-description-input',

    // Calendar Widget
    WIDGET_CONTAINER: 'scheduler-calendars-widget-container',
    WIDGET_PREV_YEAR_BUTTON: 'scheduler-calendars-widget-prev-year-button',
    WIDGET_NEXT_YEAR_BUTTON: 'scheduler-calendars-widget-next-year-button',
    WIDGET_PREV_MONTH_BUTTON: 'scheduler-calendars-widget-prev-month-button',
    WIDGET_DATE_PANEL: 'scheduler-calendars-widget-date-panel',
    WIDGET_DATE_CELL_BLANK: 'scheduler-calendars-widget-date-cell-blank',
    WIDGET_DATE_CELL_UNSELECTED: 'scheduler-calendars-widget-date-cell-unselected',
    WIDGET_DATE_CELL_SELECTED: 'scheduler-calendars-widget-date-cell-selected',
    WIDGET_NEXT_MONTH_BUTTON: 'scheduler-calendars-widget-next-month-button',
    // Discard Changes Dialog
    DISCARD_DIALOG: 'scheduler-calendars-discard-dialog',
    DISCARD_DIALOG_CANCEL: 'scheduler-calendars-discard-dialog-cancel',
    DISCARD_DIALOG_CONFIRM: 'scheduler-calendars-discard-dialog-confirm',
    // CalendarsLibrary.tsx
    CALENDARS_WRAPPER: 'scheduler-calendars-calendars-wrapper',
    CALENDARS_CTAS: 'scheduler-calendars-calendars-ctas',
    CALENDARS_GRID: 'scheduler-calendars-calendars-grid',
    CALENDARS_LOADING: 'scheduler-calendars-calendars-loading',
    // CalendarsCreateButton.tsx
    CALENDARS_CREATE_BUTTON: 'scheduler-calendars-calendars-create-button',
    CALENDARS_CREATE_BUTTON_TOOLTIP: 'scheduler-calendars-calendars-create-button-tooltip',
    CALENDARS_CREATE_BUTTON_ICON: 'scheduler-calendars-calendars-create-button-icon',
    CALENDARS_CREATE_BUTTON_TEXT: 'scheduler-calendars-calendars-create-button-text',
    // CalendarsQueryInput.tsx
    CALENDARS_QUERY_INPUT: 'scheduler-calendars-calendars-query-input',
    CALENDARS_SEARCH_BOX: 'scheduler-calendars-calendars-search-box',
    CALENDARS_SEARCH_INPUT: 'scheduler-calendars-calendars-search-input',
    CALENDARS_SEARCH_CLOSE_ICON: 'scheduler-calendars-calendars-search-close-icon',
    // CalendarNameCellRenderer.tsx
    CALENDAR_NAME_CELL_CONTAINER: 'scheduler-calendars-calendar-name-cell-container',
    CALENDAR_NAME_CELL_TOOLTIP: 'scheduler-calendars-calendar-name-cell-tooltip',
    CALENDAR_NAME_CELL_WRAPPER: 'scheduler-calendars-calendar-name-cell-wrapper',
    CALENDAR_NAME_CTA_ICONS: 'scheduler-calendars-calendar-name-cta-icons',
    CALENDAR_NAME_MORE_MENU_TOOLTIP: 'scheduler-calendars-calendar-name-more-menu-tooltip',
    CALENDAR_NAME_MORE_MENU_ICON: 'scheduler-calendars-calendar-name-more-menu-icon',
    CALENDAR_NAME_CONTEXT_MENU: 'scheduler-calendars-calendar-name-context-menu',
    CALENDAR_NAME_CONTEXT_MENU_EDIT: 'scheduler-calendars-calendar-name-context-menu-edit',
    CALENDAR_NAME_CONTEXT_MENU_DUPLICATE: 'scheduler-calendars-calendar-name-context-menu-duplicate',
    CALENDAR_NAME_CONTEXT_MENU_ARCHIVE: 'scheduler-calendars-calendar-name-context-menu-archive',
    CALENDAR_NAME_CONTEXT_MENU_UNARCHIVE: 'scheduler-calendars-calendar-name-context-menu-unarchive',
    // CalendarWidget.tsx
    CALENDAR_WIDGET_CONTAINER: 'scheduler-calendars-calendar-widget-container',
    CALENDAR_WIDGET_HEADER: 'scheduler-calendars-calendar-widget-header',
    CALENDAR_WIDGET_PREV_YEAR: 'scheduler-calendars-calendar-widget-prev-year',
    CALENDAR_WIDGET_YEAR: 'scheduler-calendars-calendar-widget-year',
    CALENDAR_WIDGET_NEXT_YEAR: 'scheduler-calendars-calendar-widget-next-year',
    CALENDAR_WIDGET_PREV_MONTH: 'scheduler-calendars-calendar-widget-prev-month',
    CALENDAR_WIDGET_NEXT_MONTH: 'scheduler-calendars-calendar-widget-next-month',
    CALENDAR_WIDGET_MONTH_GRID: 'scheduler-calendars-calendar-widget-month-grid',
    CALENDAR_WIDGET_DATE_CELL: 'scheduler-calendars-calendar-widget-date-cell',
    CALENDAR_WIDGET_INFO: 'scheduler-calendars-calendar-widget-info',
    // CalendarWizard.tsx
    CALENDAR_WIZARD_DIALOG: 'scheduler-calendars-calendar-wizard-dialog',
    CALENDAR_WIZARD_CLOSE_BUTTON: 'scheduler-calendars-calendar-wizard-close-button',
    CALENDAR_WIZARD_CLOSE_ICON: 'scheduler-calendars-calendar-wizard-close-icon',
    CALENDAR_WIZARD_TITLE: 'scheduler-calendars-calendar-wizard-title',
    CALENDAR_WIZARD_NEXT_BUTTON: 'scheduler-calendars-calendar-wizard-next-button',
    CALENDAR_WIZARD_BACK_BUTTON: 'scheduler-calendars-calendar-wizard-back-button',
    CALENDAR_WIZARD_SAVE_BUTTON: 'scheduler-calendars-calendar-wizard-save-button',

    // DialogPage1.tsx
    DIALOG_PAGE1_CONTAINER: 'scheduler-calendars-dialog-page1-container',
    DIALOG_PAGE1_NAME_INPUT: 'scheduler-calendars-dialog-page1-name-input',
    DIALOG_PAGE1_DESCRIPTION_INPUT: 'scheduler-calendars-dialog-page1-description-input',
    DIALOG_PAGE1_CHAR_ERROR: 'scheduler-calendars-dialog-page1-char-error',
    // DialogPage2.tsx
    DIALOG_PAGE2_CONTAINER: 'scheduler-calendars-dialog-page2-container',
    // WorkingDays.tsx
    WORKING_DAYS_CONTAINER: 'scheduler-calendars-working-days-container',
    WORKING_DAYS_BUTTON_SUNDAY: 'scheduler-calendars-working-days-button-sunday',
    WORKING_DAYS_BUTTON_MONDAY: 'scheduler-calendars-working-days-button-monday',
    WORKING_DAYS_BUTTON_TUESDAY: 'scheduler-calendars-working-days-button-tuesday',
    WORKING_DAYS_BUTTON_WEDNESDAY: 'scheduler-calendars-working-days-button-wednesday',
    WORKING_DAYS_BUTTON_THURSDAY: 'scheduler-calendars-working-days-button-thursday',
    WORKING_DAYS_BUTTON_FRIDAY: 'scheduler-calendars-working-days-button-friday',
    WORKING_DAYS_BUTTON_SATURDAY: 'scheduler-calendars-working-days-button-saturday',

    // ArchivedCalendars.tsx
    ARCHIVED_CALENDARS_WRAPPER: 'scheduler-calendars-archived-calendars-wrapper',
    ARCHIVED_CALENDARS_BUTTON: 'scheduler-calendars-archived-calendars-button',

    // ArchivedCalendarsDialog.tsx
    ARCHIVED_CALENDARS_DIALOG_CONTAINER: 'scheduler-calendars-archived-calendars-dialog-container',
    ARCHIVED_CALENDARS_DIALOG_CLOSE_BUTTON: 'scheduler-calendars-archived-calendars-dialog-close-button',
    ARCHIVED_CALENDARS_DIALOG_TITLE: 'scheduler-calendars-archived-calendars-dialog-title',
    ARCHIVED_CALENDARS_DIALOG_CONTENT: 'scheduler-calendars-archived-calendars-dialog-content',

    // ArchiveCalendarAlertDialog.tsx
    ARCHIVE_CALENDAR_ALERT_DIALOG_CONTAINER: 'scheduler-calendars-archive-calendar-alert-dialog-container',
    ARCHIVE_CALENDAR_ALERT_DIALOG_CLOSE_BUTTON: 'scheduler-calendars-archive-calendar-alert-dialog-close-button',
    ARCHIVE_CALENDAR_ALERT_DIALOG_TITLE: 'scheduler-calendars-archive-calendar-alert-dialog-title',
    ARCHIVE_CALENDAR_ALERT_DIALOG_CONTENT: 'scheduler-calendars-archive-calendar-alert-dialog-content',
    ARCHIVE_CALENDAR_ALERT_DIALOG_CANCEL_BUTTON: 'scheduler-calendars-archive-calendar-alert-dialog-cancel-button',
    ARCHIVE_CALENDAR_ALERT_DIALOG_CONFIRM_BUTTON: 'scheduler-calendars-archive-calendar-alert-dialog-confirm-button',

    // DiscardChangesDialog.tsx
    DISCARD_CHANGES_DIALOG_CONTAINER: 'scheduler-calendars-discard-changes-dialog-container',
    DISCARD_CHANGES_DIALOG_CONTENT: 'scheduler-calendars-discard-changes-dialog-content',
    DISCARD_CHANGES_DIALOG_LEAVE_BUTTON: 'scheduler-calendars-discard-changes-dialog-leave-button',
    DISCARD_CHANGES_DIALOG_STAY_BUTTON: 'scheduler-calendars-discard-changes-dialog-stay-button',

    // Stepper.tsx
    STEPPER_CONTAINER: 'scheduler-calendars-stepper-container',
    STEPPER_STEP_1: 'scheduler-calendars-stepper-step-1',
    STEPPER_STEP_2: 'scheduler-calendars-stepper-step-2',
    STEPPER_STEP_DEFAULT_WORK_WEEK: 'scheduler-calendars-stepper-step-default-work-week',
    CALENDAR_NAME_MORE_MENU_CONTAINER: 'scheduler-calendars-calendar-name-more-menu-container',
    CALENDAR_NAME_MORE_MENU_INFO_ICON: 'scheduler-calendars-calendar-name-more-menu-info-icon',
    CALENDAR_NAME_MORE_MENU_ARCHIVE_BUTTON: 'scheduler-calendars-calendar-name-more-menu-archive-button',
    STEPPER_STEP_DEFAULT_WORK_WEEK_NUM: 'scheduler-calendars-stepper-step-default-work-week-num',
    STEPPER_STEP_DEFAULT_WORK_WEEK_TEXT: 'scheduler-calendars-stepper-step-default-work-week-text',
    STEPPER_STEP_CUSTOMIZE_WORK_DAYS: 'scheduler-calendars-stepper-step-customize-work-days'
  },
  FIND_REPLACE_DIALOG: {
    DIALOG: 'scheduler-find-replace-dialog',
    DIALOG_TITLE: 'scheduler-find-replace-dialog-title',
    DIALOG_CONTENT: 'scheduler-find-replace-dialog-content',
    CANCEL_BUTTON: 'scheduler-find-replace-cancel-button',
    ORIGINAL_NAMES_COLUMN: 'scheduler-find-replace-original-names-column',
    RENAMED_COLUMN: 'scheduler-find-replace-renamed-column'
  },
  GANTT_PLUS_TABLE: {
    FLEX_WRAPPER: 'scheduler-gantt-plus-table-flex-wrapper',
    CANVAS_APP_BAR: 'scheduler-gantt-plus-table-canvas-app-bar',
    ORGANIZATION_ITEM: 'scheduler-gantt-plus-table-organization-item',
    MAIN_NAV_LEFT_ELEMENTS: 'scheduler-gantt-plus-table-main-nav-left-elements',
    NAV_COMMENTS_BUTTON: 'scheduler-gantt-plus-table-nav-comments-button',
    NAV_COLLABORATORS: 'scheduler-gantt-plus-table-nav-collaborators',
    MAIN_NAV_MIDDLE_ELEMENTS: 'scheduler-gantt-plus-table-main-nav-middle-elements',
    MAIN_PROJECT_TITLE: 'scheduler-gantt-plus-table-main-project-title',
    PDF_LOGO_SECTION: 'scheduler-gantt-plus-table-pdf-logo-section',
    MAIN_NAV_RIGHT_ELEMENTS: 'scheduler-gantt-plus-table-main-nav-right-elements'
  },
  ORGANIZATION_FIELDS: {
    LIBRARY_CONTAINER: 'scheduler-organization-fields-library-container',
    CREATE_BUTTON_CONTAINER: 'scheduler-organization-fields-create-button-container',
    CREATE_BUTTON: 'scheduler-organization-fields-create-button',
    CREATE_BUTTON_TOOLTIP: 'scheduler-organization-fields-create-button-tooltip',
    GRID_CONTAINER: 'scheduler-organization-fields-grid-container',
    GRID: 'scheduler-organization-fields-grid',
    ARCHIVES_WRAPPER: 'scheduler-organization-fields-archives-wrapper',
    ARCHIVES_BUTTON: 'scheduler-organization-fields-archives-button',
    ACTION_MENU_CONTAINER: 'scheduler-organization-fields-action-menu-container',
    ACTION_MENU_BUTTON: 'scheduler-organization-fields-action-menu-button',
    ACTION_MENU_POPOVER: 'scheduler-organization-fields-action-menu-popover',
    CREATE_EDIT_DIALOG: 'scheduler-organization-fields-create-edit-dialog',
    CREATE_EDIT_DIALOG_TITLE: 'scheduler-organization-fields-create-edit-dialog-title',
    CREATE_EDIT_DIALOG_CONTENT: 'scheduler-organization-fields-create-edit-dialog-content',
    CREATE_EDIT_NAME_INPUT: 'scheduler-organization-fields-create-edit-name-input',
    CREATE_EDIT_TYPE_SELECT: 'scheduler-organization-fields-create-edit-type-select',
    CREATE_EDIT_CANCEL_BUTTON: 'scheduler-organization-fields-create-edit-cancel-button',
    CREATE_EDIT_SAVE_BUTTON: 'scheduler-organization-fields-create-edit-save-button',
    ARCHIVED_DIALOG: 'scheduler-organization-fields-archived-dialog',
    ARCHIVED_DIALOG_CLOSE_BUTTON: 'scheduler-organization-fields-archived-dialog-close-button',
    ARCHIVED_DIALOG_TITLE: 'scheduler-organization-fields-archived-dialog-title',
    ARCHIVED_DIALOG_CONTENT: 'scheduler-organization-fields-archived-dialog-content',
    ARCHIVE_ALERT_DIALOG: 'scheduler-organization-fields-archive-alert-dialog',
    ARCHIVE_ALERT_DIALOG_CLOSE_BUTTON: 'scheduler-organization-fields-archive-alert-dialog-close-button',
    ARCHIVE_ALERT_DIALOG_TITLE: 'scheduler-organization-fields-archive-alert-dialog-title',
    ARCHIVE_ALERT_DIALOG_CONTENT: 'scheduler-organization-fields-archive-alert-dialog-content',
    ARCHIVE_ALERT_CANCEL_BUTTON: 'scheduler-organization-fields-archive-alert-cancel-button',
    ARCHIVE_ALERT_CONFIRM_BUTTON: 'scheduler-organization-fields-archive-alert-confirm-button',
    OPTIONS_DROPDOWN_POPOVER: 'scheduler-organization-fields-options-dropdown-popover',
    OPTIONS_DROPDOWN_SEARCH_ICON: 'scheduler-organization-fields-options-dropdown-search-icon',
    OPTIONS_DROPDOWN_SEARCH_INPUT: 'scheduler-organization-fields-options-dropdown-search-input',
    OPTIONS_DROPDOWN_ITEM: 'scheduler-organization-fields-options-dropdown-item',
    ADD_CHIP: 'scheduler-organization-fields-add-chip',
    CREATE_EDIT_DIALOG_CLOSE_BUTTON: 'scheduler-organization-fields-create-edit-dialog-close-button',
    OPTIONS_EDITOR_CONTAINER: 'scheduler-organization-fields-options-editor-container',
    OPTIONS_EDITOR_INPUT: 'scheduler-organization-fields-options-editor-input',
    OPTIONS_EDITOR_COLOR_BUTTON: 'scheduler-organization-fields-options-editor-color-button',
    OPTIONS_EDITOR_DELETE_BUTTON: 'scheduler-organization-fields-options-editor-delete-button',
    COLOR_POPOVER: 'scheduler-organization-fields-color-popover',
    DELETE_UPDATE_TAG_DIALOG: 'scheduler-organization-fields-delete-update-tag-dialog',
    DELETE_UPDATE_TAG_DIALOG_CONTENT: 'scheduler-organization-fields-delete-update-tag-dialog-content',
    DELETE_UPDATE_TAG_KEEP_BUTTON: 'scheduler-organization-fields-delete-update-tag-keep-button',
    DELETE_UPDATE_TAG_CONFIRM_BUTTON: 'scheduler-organization-fields-delete-update-tag-confirm-button'
  },
  PRESENCE: {
    HEADER_CONTAINER: 'scheduler-presence-header-container',
    DROPDOWN_POPOVER: 'scheduler-presence-dropdown-popover',
    DROPDOWN_CURRENT_USER_ROW: 'scheduler-presence-dropdown-current-user-row',
    DROPDOWN_USER_ROW: 'scheduler-presence-dropdown-user-row',
    DROPDOWN_TOGGLE_CURSOR_ROW: 'scheduler-presence-dropdown-toggle-cursor-row',
    DROPDOWN_LOCATE_ICON: 'scheduler-presence-dropdown-locate-icon',
    AVATAR_PLUS_BUTTON_BUSY_TOOLTIP: 'scheduler-presence-avatar-plus-button-busy-tooltip',
    AVATAR_PLUS_BUTTON_CURSOR_TOOLTIP: 'scheduler-presence-avatar-plus-button-cursor-tooltip',
    AVATAR_PLUS_BUTTON_CLICKABLE: 'scheduler-presence-avatar-plus-button-clickable',
    PRESENCE_AVATAR_TOOLTIP: 'scheduler-presence-avatar-tooltip',
    PRESENCE_AVATAR_CLICKABLE: 'scheduler-presence-avatar-clickable',
    AVATAR_CONTAINER: 'scheduler-presence-avatar-container',
    BUSY_TOOLTIP_CLOSE_BUTTON: 'scheduler-presence-busy-tooltip-close-button',
    CURSOR_CONTAINER: 'scheduler-presence-cursor-container'
  },
  PROJECT: {
    COMPONENT_WRAPPER: 'scheduler-project-component-wrapper',
    NAVIGATION_WAIT_STATE_CONTAINER: 'scheduler-project-navigation-wait-state-container',
    CANVAS_APP_BAR: 'scheduler-project-canvas-app-bar',
    MAIN_NAV_LEFT_ELEMENTS: 'scheduler-project-main-nav-left-elements',
    NAV_COLLABORATORS: 'scheduler-project-nav-collaborators',
    MAIN_NAV_MIDDLE_ELEMENTS: 'scheduler-project-main-nav-middle-elements',
    MAIN_NAV_RIGHT_ELEMENTS: 'scheduler-project-main-nav-right-elements'
  },
  READ_ONLY_BUTTON: {
    MAIN_BUTTON: 'scheduler-read-only-button-main-button',
    POPOVER: 'scheduler-read-only-button-popover',
    POPOVER_CONTENTS: 'scheduler-read-only-button-popover-contents',
    MAKE_EDITABLE_BUTTON: 'scheduler-read-only-button-make-editable',
    USERNAME_TOOLTIP: 'scheduler-read-only-button-username-tooltip',
    PROJECT_OWNERS_LIST_ITEM: 'scheduler-read-only-button-project-owners-list-item'
  },
  BOOKMARKS: {
    // BookmarkButton.tsx
    BOOKMARK_BUTTON_IPAD: 'scheduler-bookmarks-bookmark-button-ipad',
    BOOKMARK_BUTTON_DESKTOP: 'scheduler-bookmarks-bookmark-button-desktop',
    BOOKMARK_BUTTON_TOOLTIP: 'scheduler-bookmarks-bookmark-button-tooltip',
    BOOKMARK_ICON_BUSY: 'scheduler-bookmarks-bookmark-icon-busy',
    BOOKMARK_ICON_READY: 'scheduler-bookmarks-bookmark-icon-ready',
    BOOKMARK_BUTTON_TEXT: 'scheduler-bookmarks-bookmark-button-text',
    BOOKMARK_LOADER: 'scheduler-bookmarks-bookmark-loader',

    // BookmarkTile.tsx
    BOOKMARK_TILE_CONTAINER: 'scheduler-bookmarks-bookmark-tile-container',
    BOOKMARK_ICON_WRAPPER: 'scheduler-bookmarks-bookmark-icon-wrapper',
    BOOKMARK_DETAILS_CONTAINER: 'scheduler-bookmarks-bookmark-details-container',
    BOOKMARK_TITLE: 'scheduler-bookmarks-bookmark-title',
    BOOKMARK_DESCRIPTION: 'scheduler-bookmarks-bookmark-description',
    BOOKMARK_MOVE_BAR: 'scheduler-bookmarks-bookmark-move-bar',
    BOOKMARK_MORE_MENU_BUTTON: 'scheduler-bookmarks-bookmark-more-menu-button',
    BOOKMARK_MORE_MENU_ICON: 'scheduler-bookmarks-bookmark-more-menu-icon',
    BOOKMARK_CONTEXT_MENU: 'scheduler-bookmarks-bookmark-context-menu',
    BOOKMARK_CONTEXT_MENU_EDIT: 'scheduler-bookmarks-bookmark-context-menu-edit',
    BOOKMARK_CONTEXT_MENU_COPY: 'scheduler-bookmarks-bookmark-context-menu-copy',
    BOOKMARK_CONTEXT_MENU_DELETE: 'scheduler-bookmarks-bookmark-context-menu-delete',
    BOOKMARK_MENU_TEXT_LABEL: 'scheduler-bookmarks-bookmark-menu-text-label',
    BOOKMARK_CONTEXT_ICON_RENAME: 'scheduler-bookmarks-bookmark-context-icon-rename',
    BOOKMARK_CONTEXT_ICON_LINK: 'scheduler-bookmarks-bookmark-context-icon-link',
    BOOKMARK_CONTEXT_ICON_DELETE: 'scheduler-bookmarks-bookmark-context-icon-delete',

    // BookmarksPanel.tsx
    BOOKMARKS_MAIN_BODY: 'scheduler-bookmarks-bookmarks-main-body',
    BOOKMARKS_PANEL_DIALOG: 'scheduler-bookmarks-bookmarks-panel-dialog',
    BOOKMARKS_PANEL_TITLE: 'scheduler-bookmarks-bookmarks-panel-title',
    BOOKMARKS_PANEL_TOOLTIP: 'scheduler-bookmarks-bookmarks-panel-tooltip',
    BOOKMARKS_PANEL_TOOLTIP_CONTENT: 'scheduler-bookmarks-bookmarks-panel-tooltip-content',
    BOOKMARKS_PANEL_SEARCH_ICON_BUTTON: 'scheduler-bookmarks-bookmarks-panel-search-icon-button',
    BOOKMARKS_PANEL_SEARCH_ICON: 'scheduler-bookmarks-bookmarks-panel-search-icon',
    BOOKMARKS_PANEL_CLOSE_BUTTON: 'scheduler-bookmarks-bookmarks-panel-close-button',
    BOOKMARKS_PANEL_CLOSE_ICON: 'scheduler-bookmarks-bookmarks-panel-close-icon',
    BOOKMARKS_PANEL_SEARCH_INPUT: 'scheduler-bookmarks-bookmarks-panel-search-input',
    BOOKMARKS_PANEL_SEARCH_WRAPPER: 'scheduler-bookmarks-bookmarks-panel-search-wrapper',
    BOOKMARKS_PANEL_WRAPPER_LIST: 'scheduler-bookmarks-bookmarks-panel-wrapper-list',
    BOOKMARKS_PANEL_PLACEHOLDER: 'scheduler-bookmarks-bookmarks-panel-placeholder',
    BOOKMARKS_PANEL_BOOKMARK_VIEW_BUTTON: 'scheduler-bookmarks-bookmarks-panel-bookmark-view-button',
    BOOKMARKS_PANEL_COPY_LINK_BUTTON: 'scheduler-bookmarks-bookmarks-panel-copy-link-button',
    BOOKMARKS_PANEL_LOADER: 'scheduler-bookmarks-bookmarks-panel-loader',

    // BookmarkDialog.tsx
    BOOKMARK_DIALOG_CONTAINER: 'scheduler-bookmarks-bookmark-dialog-container',
    BOOKMARK_DIALOG_CLOSE_BUTTON: 'scheduler-bookmarks-bookmark-dialog-close-button',
    BOOKMARK_DIALOG_CLOSE_ICON: 'scheduler-bookmarks-bookmark-dialog-close-icon',
    BOOKMARK_DIALOG_TITLE: 'scheduler-bookmarks-bookmark-dialog-title',
    BOOKMARK_DIALOG_CANCEL_BUTTON: 'scheduler-bookmarks-bookmark-dialog-cancel-button',
    TITLE_INPUT_FIELD: 'bookmark-title-input-field',
    DESCRIPTION_INPUT_FIELD: 'bookmark-description-input-field',
    CREATE_BUTTON: 'bookmark-create-button',
    UPDATE_BUTTON: 'bookmark-update-button'
  },
  CONSTRAINT_PICKER: {
    // ConstraintPicker.tsx
    CONSTRAINT_PICKER_POPOVER: 'scheduler-constraint-picker-constraint-picker-popover',
    CONSTRAINT_INPUT_ROW: 'scheduler-constraint-picker-constraint-input-row',
    CONSTRAINT_LABEL: 'scheduler-constraint-picker-constraint-label',
    CONSTRAINT_SELECT_INPUT: 'scheduler-constraint-picker-constraint-select-input',
    CONSTRAINT_MENU_ITEM: 'scheduler-constraint-picker-constraint-menu-item',
    CONSTRAINT_MENU_ITEM_TEXT: 'scheduler-constraint-picker-constraint-menu-item-text',
    CONSTRAINT_MENU_TICK: 'scheduler-constraint-picker-constraint-menu-tick',
    DATE_INPUT_ROW: 'scheduler-constraint-picker-date-input-row',
    DATE_LABEL: 'scheduler-constraint-picker-date-label',
    DATE_PICKER: 'scheduler-constraint-picker-date-picker',

    // ConstraintPickerNew.tsx
    CONSTRAINT_PICKER_NEW_POPOVER: 'scheduler-constraint-picker-constraint-picker-new-popover',
    CONSTRAINT_MENU_ITEM_CONTAINER: 'scheduler-constraint-picker-constraint-menu-item-container',
    CONSTRAINT_NEW_MENU_ITEM: 'scheduler-constraint-picker-constraint-new-menu-item',
    CONSTRAINT_NEW_MENU_ITEM_TEXT: 'scheduler-constraint-picker-constraint-new-menu-item-text',
    CONSTRAINT_NEW_MENU_TICK: 'scheduler-constraint-picker-constraint-new-menu-tick',
    CALENDAR_DATE_ROW: 'scheduler-constraint-picker-calendar-date-row',
    NEW_DATE_PICKER: 'scheduler-constraint-picker-new-date-picker'
  },
  RUN_CPM_BUTTON: {
    // PreCPMAuditPopup elements
    INSPECT_ACTIVITIES_LINK: 'run-cpm-button-inspect-activities-link',
    TIP_CLOSE_BUTTON: 'run-cpm-button-tip-close-button',
    MOVE_LATER_BUTTON: 'run-cpm-button-move-later-button',
    MOVE_NOW_BUTTON: 'run-cpm-button-move-now-button',
    PRECPM_CANCEL_BUTTON: 'run-cpm-button-precpm-cancel-button',
    PRECPM_SCHEDULE_BUTTON: 'run-cpm-button-precpm-schedule-button',

    // RunCPMErrorPopup elements
    STARTING_ELEMENT_LINK: 'run-cpm-button-starting-element-link',
    ENDING_ELEMENT_LINK: 'run-cpm-button-ending-element-link',

    // RunCPMStatusPopup elements
    STATUS_CLOSE_BUTTON: 'run-cpm-button-status-close-button',
    WARNINGS_TOGGLE_LINK: 'run-cpm-button-warnings-toggle-link',
    ZERO_DURATION_CHECKBOX: 'run-cpm-button-zero-duration-checkbox',
    NO_PREDECESSOR_CHECKBOX: 'run-cpm-button-no-predecessor-checkbox',
    NO_SUCCESSOR_CHECKBOX: 'run-cpm-button-no-successor-checkbox',
    SEE_WARNINGS_BUTTON: 'run-cpm-button-see-warnings-button',
    IMPROVE_SCORE_LINK: 'run-cpm-button-improve-score-link',

    // AlertDialogToRemoveFilters elements
    ALERT_CLOSE_BUTTON: 'run-cpm-button-alert-close-button',
    DONT_SHOW_AGAIN_CHECKBOX: 'run-cpm-button-dont-show-again-checkbox',
    DONT_SHOW_AGAIN_LABEL: 'run-cpm-button-dont-show-again-label',
    ALERT_CANCEL_BUTTON: 'run-cpm-button-alert-cancel-button',
    ALERT_CONTINUE_BUTTON: 'run-cpm-button-alert-continue-button'
  },
  STALE_SCHEDULE_ALERT: {
    // StaleScheduleAlert elements
    CLOSE_BUTTON: 'stale-schedule-alert-close-button'
  }
} as const;
